import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
@Injectable()
export class ContextService {

  private showNav: boolean;

  constructor() {
    this.showNav = true;
  }

  setShowNav(val: boolean) {
     this.showNav = val;
  }

  getShowNav() {
    return this.showNav;
  }

}
